import { Controller } from 'stimulus'

const POLL_INTERVAL_MS = 2000

export default class extends Controller {
  static targets = ['status']

  static values = {
    activeRunId: String,
    projectUrl: String,
    statusUrlTemplate: String,
  }

  connect() {
    this.pollTimer = null
    this.terminalHandled = false
    if (!this.hasActiveRunIdValue || !this.activeRunIdValue) return

    this.fetchStatus()
    this.pollTimer = window.setInterval(() => this.fetchStatus(), POLL_INTERVAL_MS)
  }

  disconnect() {
    if (this.pollTimer) window.clearInterval(this.pollTimer)
    this.pollTimer = null
  }

  async fetchStatus() {
    try {
      const response = await fetch(this.statusUrl(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
      if (!response.ok) return

      const payload = await response.json()
      if (this.hasStatusTarget && payload.message) this.statusTarget.textContent = payload.message
      if (payload.terminal === true) this.handleTerminal(payload)
    } catch (_error) {
      // Keep polling. A temporary network failure must not restart pricing.
    }
  }

  handleTerminal(payload) {
    if (this.terminalHandled) return

    this.terminalHandled = true
    if (this.pollTimer) window.clearInterval(this.pollTimer)
    this.pollTimer = null
    window.location = payload.project_url || this.projectUrlValue || window.location.href
  }

  statusUrl() {
    return this.statusUrlTemplateValue.replace('__RUN_ID__', encodeURIComponent(this.activeRunIdValue))
  }
}
